module.exports = __webpack_public_path__ + "static/media/lp4.85d2b01d.jpg";